<section class="monitoring-section">
  @if (isLoading$ | async) {
    <div class="loading-indicator">
      <mat-spinner [diameter]="50"></mat-spinner>
    </div>
  } @else if (errorMessage$ | async) {
    <div class="error-message">
      {{ errorMessage$ | async }}
    </div>
  } @else {
    @if (downNodes$ | async; as nodes) {
      <div class="wide-view">
        <div class="column status">
          <div class="icon-text header">
            <div class="custom-icon monitoring_lrg"></div>
            <h1>Network Status</h1>
          </div>

          <div
            class="status-icon"
            [ngClass]="{ up: nodes.length === 0, down: nodes.length > 0 }"
          ></div>
        </div>

        @if (nodes.length > 0) {
          <div class="column nodes">
            <h2>
              {{ nodes.length }} critical node{{ nodes.length > 1 ? "s" : "" }}
            </h2>
            <div class="node-container">
              @for (node of nodes.slice(0, 2); track node.NITNumber) {
                <div class="node-row">
                  <div class="custom-icon health_down"></div>
                  <div class="node-details">
                    <div class="icon-text nit-container">
                      <div class="custom-icon circuit_critical"></div>
                      <div class="nit-number">{{ node.NITNumber }}</div>
                    </div>
                    @if (node.FormattedAddress) {
                      <div class="icon-text address-container">
                        <div class="custom-icon location_dark"></div>
                        <div class="address">{{ node.FormattedAddress }}</div>
                      </div>
                    }
                  </div>
                </div>
              }
              @if (nodes.length > 2) {
                <div class="more-nodes divider">
                  {{ nodes.length - 2 }} More...
                </div>
              }
            </div>
          </div>
        } @else {
          <div class="column nodes healthy">
            <div class="node-container">
              <div class="number-callout">
                <h1>0</h1>
                <div>
                  <div class="status">critical</div>
                  <div class="label">Nodes</div>
                </div>
              </div>
            </div>
          </div>
        }
      </div>

      <div class="narrow-view">
        <div class="icon-text header">
          <div class="custom-icon monitoring_lrg"></div>
          <h1>Network Status</h1>
        </div>
        @if (nodes.length > 0) {
          <div class="column nodes critical">
            <div class="number-callout">
              <h1>{{ nodes.length }}</h1>
              <div>
                <div class="status">critical</div>
                <div class="label">Node{{ nodes.length > 1 ? "s" : "" }}</div>
              </div>
            </div>
            <div class="node-row">
              <div class="custom-icon health_down"></div>
              <div class="node-details">
                <div class="icon-text nit-container">
                  <div class="custom-icon circuit_critical"></div>
                  <div>{{ nodes[0].NITNumber }}</div>
                </div>
                @if (nodes[0].FormattedAddress) {
                  <div class="icon-text address-container">
                    <div class="custom-icon location_dark"></div>
                    <div class="address">{{ nodes[0].FormattedAddress }}</div>
                  </div>
                }
              </div>
            </div>
            @if (nodes.length > 1) {
              <div class="more-nodes divider">
                {{ nodes.length - 1 }} More...
              </div>
            }
          </div>
        } @else {
          <div class="healthy-container">
            <h2>No Critical Nodes.</h2>
            <div class="status-icon up"></div>
          </div>
        }
      </div>
    }

    @if (orionURL$ | async; as orionURL) {
      <div class="widget_cta">
        <a [attr.href]="orionURL" target="_blank">
          View Network Monitoring
          <div class="custom-icon btn_external"></div>
        </a>
      </div>
      <a
        [attr.href]="orionURL"
        target="_blank"
        tabindex="-1"
        class="dashboard-link desktop"
      >
        <div class="cta-link">desktop</div>
      </a>
    }
  }
</section>
